import { containerStyles } from './container.styles';
import { containerTemplate } from './container.template';
import { MediaSizeMixin } from '../../utilities/media-size-observer';
import { FASTElement } from '@microsoft/fast-element';
import { NatGenDesignSystem } from '../../natgen-design-system';

/**
 * @element natgen-container
 */
export class NatGenContainer extends MediaSizeMixin(FASTElement) {

}

export const natgGenContainerDefinition = NatGenContainer.compose({
    name: `${NatGenDesignSystem.prefix}-container`,
    template: containerTemplate,
    styles: containerStyles
});
